import HttpClient from "@/common/boot/HttpClient"
import criarToast from '@/common/boot/ToastsHandler'

const listarTarefasMobilidades = async ({ commit }, payload = {}) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.get('/ctrl-tarefas-mobilidades', { params: payload });
    commit('LISTAR_DADOS', response.data.data);
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao listar tarefas mobilidades' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const cadastrarTarefaMobilidade = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.post('/ctrl-tarefas-mobilidades', payload);
    criarToast({ tipo: 'success', mensagem: 'Tarefa mobilidade cadastrada com sucesso!' });
    dispatch('listarTarefasMobilidades');
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao cadastrar tarefa mobilidade' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const detalharTarefaMobilidade = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.get(`/ctrl-tarefas-mobilidades/${payload}`);
    commit('INSERIR_TAREFA_MOBILIDADE_SELECIONADA', response.data.data);
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao buscar tarefa mobilidade' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const atualizarTarefaMobilidade = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.put(`/ctrl-tarefas-mobilidades/${payload.id}`, payload);
    criarToast({ tipo: 'success', mensagem: 'Tarefa mobilidade atualizada com sucesso!' });
    dispatch('listarTarefasMobilidades');
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao atualizar tarefa mobilidade' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const excluirTarefaMobilidade = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.delete(`/ctrl-tarefas-mobilidades/${payload}`);
    criarToast({ tipo: 'success', mensagem: 'Tarefa mobilidade excluída com sucesso!' });
    dispatch('listarTarefasMobilidades');
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao excluir tarefa mobilidade' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const restaurarTarefaMobilidade = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.post(`/ctrl-tarefas-mobilidades/${payload}/restaurar`);
    criarToast({ tipo: 'success', mensagem: 'Tarefa mobilidade restaurada com sucesso!' });
    dispatch('listarTarefasMobilidades');
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao restaurar tarefa mobilidade' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const listarMobilidadesPorTarefaOrigem = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const response = await HttpClient.get(`/ctrl-tarefas-mobilidades/origem/${payload.ctrl_tarefa_id}`);
    commit('LISTAR_DADOS', response.data);
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao listar mobilidades da tarefa' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const listarTarefasDestinoDisponiveis = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  
  try {
    const params = {
      ctrl_tarefa_origem_id: payload.ctrl_tarefa_origem_id,
      ctrl_tratativa_id: payload.ctrl_tratativa_id
    };

    console.log(params);
    
    const response = await HttpClient.get('/ctrl-tarefas-mobilidades/destinos/disponiveis', { params });

    console.log(response.data);

    commit('LISTAR_TAREFAS_DESTINO', response.data);
    return response;
  } catch (error) {
    criarToast({ tipo: 'error', mensagem: 'Erro ao listar tarefas destino disponíveis' });
    throw error;
  } finally {
    commit('CARREGANDO', false);
  }
}

const associarAcoesIntegradas = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  HttpClient.post(`/gestao-producao/mobilidade-tarefas/${payload.ctrl_tarefa_mobilidade_id}/associar-acoes-integradas`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarTarefaMobilidadePorId = async ({ commit }, payload) => {

  commit('CARREGANDO', true);
  
  await HttpClient.get(`/gestao-producao/tarefas-mobilidades/${payload}`, payload).then(response => {
      commit('INSERIR_TAREFA_MOBILIDADE_SELECIONADA', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarAcoesIntegradasPorTarefaMobilidade = async ({ commit }, payload) => {

  commit('CARREGANDO', true);
  
  await HttpClient.get(`/gestao-producao/mobilidade-tarefas/${payload}/associar-acoes-integradas`, payload).then(response => {
      commit('LISTAR_DADOS', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarTarefaMobilidade = async ({ commit }, payload) => {

  commit('CARREGANDO', true);
  
  await HttpClient.get(`/gestao-producao/tarefas/${payload}/associar-tarefas`, payload).then(response => {
      commit('INSERIR_TAREFA_MOBILIDADE_SELECIONADA', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const associarTarefaMobilidade = async ({ commit }, payload) => {
  commit('CARREGANDO', true);


  HttpClient.post(`/gestao-producao/tarefas/${payload.ctrl_tarefa_origem_id}/associar-tarefas`, payload).then(response => {
    criarToast ({tipo: 'success', mensagem: 'Tarefas associadas com sucesso!'})
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const associarFormularioMobilidade = async ({ commit }, payload) => {
  commit('CARREGANDO', true);


  HttpClient.post(`/gestao-producao/mobilidade-tarefas/${payload.id}/associar-formulario`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarMobilidadeTarefaOrigem = async ({ commit }, payload) => {

  commit('CARREGANDO', true);
  
  await HttpClient.get(`/gestao-producao/mobilidade-tarefas/${ payload.ctrl_tarefa_id }`, { params: payload }).then(response => {
      commit('INSERIR_MOBILIDADE_TAREFA_ORIGEM_SELECIONADA', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarMobilidadePorFormulario = async ({ commit }, payload) => {

  commit('CARREGANDO_MOBILIDADE_FORMULARIO', true);

  await HttpClient.get(`/gestao-producao/mobilidade-tarefas/${ payload.ctrl_formulario_id }/listar-mobilidades-formulario`, { params: payload }).then(response => {
      commit('INSERIR_MOBILIDADE_FORMULARIO_SELECIONADA', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO_MOBILIDADE_FORMULARIO', false);
  });
}

const recuperarOpcoesPorFormulario = async ({ commit }, payload) => {

  commit('CARREGANDO_OPCOES_FORMULARIO', true);

  await HttpClient.get(`/gestao-producao/ctrl-tratativas-opcoes/${ payload.ctrl_formulario_id }/listar-opcoes-formulario`, { params: payload }).then(response => {
      commit('INSERIR_OPCOES_FORMULARIO_SELECIONADA', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO_OPCOES_FORMULARIO', false);
  });
}

export {
  listarTarefasMobilidades,
  cadastrarTarefaMobilidade,
  detalharTarefaMobilidade,
  atualizarTarefaMobilidade,
  excluirTarefaMobilidade,
  restaurarTarefaMobilidade,
  listarMobilidadesPorTarefaOrigem,
  listarTarefasDestinoDisponiveis,
  recuperarTarefaMobilidadePorId,
  recuperarTarefaMobilidade,
  associarTarefaMobilidade,
  associarFormularioMobilidade,
  recuperarMobilidadeTarefaOrigem,
  listarAcoesIntegradasPorTarefaMobilidade,
  associarAcoesIntegradas,
  recuperarMobilidadePorFormulario,
  recuperarOpcoesPorFormulario
}